/* Tiloli — reco feeds (product page): "Du même fournisseur" (search vendor:) + "Vu récemment"
   (localStorage). Cards are fetched via the Section Rendering API (section tiloli-product-feed)
   and injected into the scroller. */
(function () {
  const KEY = 'tl_recent';
  function getRecent() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; } }
  function pushRecent(h) {
    if (!h) return;
    let a = getRecent().filter((x) => x !== h);
    a.unshift(h);
    localStorage.setItem(KEY, JSON.stringify(a.slice(0, 20)));
  }

  class TiloliFeed extends HTMLElement {
    async connectedCallback() {
      this.track = this.querySelector('[data-tlfeed-track]');
      this.max = parseInt(this.dataset.max || '12', 10);
      const cur = this.dataset.current;
      const curId = this.dataset.currentId;
      pushRecent(cur); // record this product view (for "recently viewed" on the next product)

      try {
        if (this.dataset.mode === 'vendor' && this.dataset.src) {
          await this.loadFrom(this.dataset.src, curId);
        } else if (this.dataset.mode === 'recently_viewed') {
          await this.loadRecent(cur);
        }
      } catch (_) { /* noop */ }

      if (this.track && this.track.children.length) {
        this.hidden = false;
        this.wireArrows();
        this.notifyPricing(); // demande au moteur de prix "own" de re-scanner les cartes injectées
      } else {
        this.closest('.tlfeed-sec')?.remove(); // nothing to show → drop the whole section
      }
    }

    // Les cartes sont injectées en AJAX → on émet des évènements pour que le moteur de prix "own"
    // re-scanne. Markup déjà prêt (.tl-price__net, data-product-id/variant-id).
    notifyPricing() {
      const section = this.closest('.shopify-section') || this;
      // 1) évènement standard Shopify (les sections re-initialisent dessus)
      try { document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: section.id } })); } catch (_) {}
      // 2) évènement Tiloli dédié (cible = ce conteneur + ses .tl-price__net)
      try {
        this.dispatchEvent(new CustomEvent('tl:cards-injected', {
          bubbles: true,
          detail: { container: this.track, prices: this.track.querySelectorAll('.tl-price__net') }
        }));
      } catch (_) {}
    }

    async fetchItems(url) {
      const res = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!res.ok) return [];
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      return [...doc.querySelectorAll('[data-tlfeed-cards] > .tlfeed-cards__item')];
    }

    async loadFrom(url, excludeId) {
      const items = (await this.fetchItems(url)).filter((it) => it.dataset.pid !== excludeId);
      items.slice(0, this.max).forEach((it) => this.track.appendChild(it));
    }

    async loadRecent(cur) {
      const handles = getRecent().filter((h) => h && h !== cur).slice(0, this.max);
      for (const h of handles) {
        const items = await this.fetchItems('/products/' + encodeURIComponent(h) + '?section_id=' + this.dataset.section);
        if (items[0]) this.track.appendChild(items[0]);
      }
    }

    wireArrows() {
      const prev = this.querySelector('[data-tlfeed-prev]');
      const next = this.querySelector('[data-tlfeed-next]');
      const step = () => {
        const c = this.track.querySelector('.tlfeed-cards__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap || '20') || 20;
        return c ? c.getBoundingClientRect().width + gap : 300;
      };
      prev && prev.addEventListener('click', () => this.track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
      next && next.addEventListener('click', () => this.track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    }
  }
  // Guard: tiloli-feed.js loads on two sections (product-feed + reco); a page with
  // both would define the element twice → NotSupportedError. Define once.
  if (!customElements.get('tiloli-feed')) customElements.define('tiloli-feed', TiloliFeed);
})();
